module.exports = __webpack_public_path__ + "img/jsmb-logo.5708a4eb.svg";